import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";

import { PageHeader, PermissionCheck } from "@/components";
import { PermissionRoles } from "@/enum";

import { SupportDashboardTable } from "./components/SupportDashboardTable";
import { SupportUsersTable } from "./components/SupportUsersTable";

enum SupportDashboardTab {
	COMPANIES = "companies",
	USERS = "users",
}

export const SupportDashboard: FunctionComponent = () => {
	const { t } = useTranslation();
	const [activeTab, setActiveTab] = useState<SupportDashboardTab>(SupportDashboardTab.COMPANIES);

	const tabs = [
		{ label: t("supportDashboard.tabs.companies"), value: SupportDashboardTab.COMPANIES },
		{ label: t("supportDashboard.tabs.users"), value: SupportDashboardTab.USERS },
	];

	return (
		<PermissionCheck requiredPermissions={[PermissionRoles.GLOBAL_ADMIN]}>
			<div className="w-full">
				<PageHeader
					activeTab={activeTab}
					tabs={tabs}
					title={t("supportDashboard.title")}
					onTabChange={(value) => setActiveTab(value as SupportDashboardTab)}
				/>
				{activeTab === SupportDashboardTab.COMPANIES ? (
					<SupportDashboardTable />
				) : (
					<SupportUsersTable />
				)}
			</div>
		</PermissionCheck>
	);
};
